import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import { setToggleVoucher } from 'store/ducks/voucher/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './voucherFilter.styles';

const VoucherFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const voucher = useSelector(
    (state: ApplicationState) => state.voucher.voucher,
  );

  const handleToggleVoucher = (voucher: boolean | null) => {
    dispatch(
      setToggleVoucher({
        voucher,
      }),
    );
  }

  return (
    <Box marginTop={1}>
      <List dense>
        {[true, false].map((status) => (
          <ListItem button key={String(status)}>
            <ListItemText
              primary={status ? 'Sim' : 'Não'}
              classes={{ root: classes.itemText }}
              onClick={() => handleToggleVoucher(status)}
            />
            <ListItemSecondaryAction>
              <Radio
                edge='end'
                color='primary'
                onClick={() => handleToggleVoucher(status)}
                checked={voucher === status}
                inputProps={{ 'aria-labelledby': 'voucher' }}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
        { voucher !== null && (
          <ListItem button className={classes.reset}>
            <ListItemText
              primary="Desfazer"
              classes={{ root: classes.itemText }}
              onClick={() => handleToggleVoucher(null)}
            />
        </ListItem>
        ) }
      </List>
    </Box>
  );
};

export { VoucherFilter };
export default VoucherFilter;
